/* eslint-disable max-lines */
import React, { useEffect, useRef, useState } from "react";
import { Modal } from "antd";
import { googleAds } from "appConfig";
import StickyBox from "react-sticky-box";

import { AdsSortOption, AllTypeCategory, ModuleNameHr, PageRoute, QueryParam } from "../../../models";
import FilterSection from "../FilterSection";
import FilterSectionLoader from "../FilterSectionLoader";
import styles from "./SearchSection.scss";
import history from "../../../history";
import {
  getUrlParams,
  stringifyURI,
  scrollToTop,
  checkEmptyObject
} from "../../../services/utils";
import { getIconUrl } from "../../../services/asset";
import AdsSection from "../AdsSection";
import { HeaderDesktop } from "./HeaderDesktop";
import HeaderMobile from "./HeaderMobile/HeaderMobile";
import ReactGA from "react-ga4";
import { updateCurrentModule } from "../../App/actions";
import { connect, useSelector, useDispatch } from "react-redux";
import { getControls } from "../../../routes/Search/search.ducks";
import { getAdvancedSearchConfig } from "../../../dataConfig";
import GoogleAd from "../../../components/GoogleAd";
import { RealEstateWidget } from "../../ModulePage/RealEstatePricesEntryBox/RealEstateWidget";
import { selectModules } from "../../App/selectors";
import useHrPageName from "../../../utils/useHrPageName";
import { useLocation } from "react-router-dom";
import AgeVerification from "../../../components/AgeVerificationModal";
import { checkEmptyArray } from "../../../services";
import { useAgeVerification } from "../../../hooks/useAgeVerification";


const AntdModalClass = "ant-modal-mask";

const SearchSection = props => {
  const {
    module: propModule,
    location,
    location: propLocation,
    updateCurrentModule: propUpdateCurrentModule,
    children,
    ads,
    categories,
    selectedCategory,
    hasSaveButton,
    numberOfControls,
    loading,
    modules,
    isMobile,
    metaData,
    categoryName,
    target,
    shouldHilightPromotedAds,
    module,
    filterHeader,
  } = props;

  const dispatch = useDispatch();

  const queryParams = useRef({
    filters: [],
    page: undefined
  });
  const prevProps = useRef(props);
  //const modalElement = useRef();
  const selectedModule = useRef(AllTypeCategory.name);
  const sortOption = useRef(undefined);
  //const cacheBodyStyle = useRef();
  //const bodyElement = useRef();
  const [isShowFilter, setIsShowFilter] = useState(false);
  const [shouldRenderFilterSection, setShouldRenderFilterSection] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const [showFloatingFilter, setShowFloatingFilter] = useState(false);

  const modalBodyStyle = { padding: 0 };
  const modalStyle = { top: 0, left: 0, margin: 0, paddingBottom: 0 };

  const allModules = useSelector(selectModules);
  const hrPageName = useHrPageName(props.selectedCategory);

  // Use unified age verification hook
  const { ageVerificationModal, shouldShowModal, forbiddAds } = useAgeVerification({
    module,
    category: selectedCategory,
    modules: allModules,
    categories
  });

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  useEffect(function () {
    var handleScroll = function () {
      setShowFloatingFilter(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll);
    return function () {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  var openAllSearchRef = useRef(null);

  var handleFloatingFilterClick = function () {
    if (isMobile) {
      handleToggleFilter();
    } else if (openAllSearchRef.current) {
      openAllSearchRef.current();
    }
  };


  useEffect(() => {
    if (isMobile) {
      const query = getUrlParams(location.search, QueryParam.searchQuery);

      const categoryFromQeury = query && query.category;
      const categoryFromPath = (location && location.pathname && location.pathname.split("/").length > 2) ? location.pathname.split("/")[2] : null;
      dispatch(getControls(
        propModule,
        categoryFromQeury || categoryFromPath,
        query || {},
        getAdvancedSearchConfig
      ));
    }
  }, [
    isMobile,
    location.search,
    location.pathname,
    propModule,
    dispatch
  ]);

  useEffect(() => {
    if (isShowFilter) {
      // On mobile, when reopening the filter modal, sync Redux controls with
      // the last submitted filter values so the form fields render with their
      // previous selections (price, brand, model, ...). Without this, only the
      // values present in the URL would pre-fill, which on pages like the
      // seller page (where URL doesn't change on filter submit) means the form
      // would always reset on each modal open.
      if (isMobile && queryParams.current.filters &&
        Object.keys(queryParams.current.filters).length > 0) {
        dispatch(getControls(
          selectedModule.current === AllTypeCategory.name
            ? undefined
            : selectedModule.current,
          queryParams.current.filters.category,
          queryParams.current.filters,
          getAdvancedSearchConfig
        ));
      }
      if (!shouldRenderFilterSection) {
        const timer = setTimeout(() => {
          setShouldRenderFilterSection(true);
        }, 100);
        return () => clearTimeout(timer);
      }
    }
  }, [isShowFilter]);

  useEffect(() => {
    if (propModule && propLocation.pathname.includes(propModule)) {
      selectedModule.current = propModule;
    } else {
      let tempModule =
        propLocation.pathname && propLocation.pathname.split("/");

      // If you reload the page, the module will be lost, and because of that
      // behavior  we are extracting it from pathname and setting it into redux
      // but we need to pay attention not to set some other part of the route
      if (tempModule && !tempModule[1].includes("pretraga")) {
        propUpdateCurrentModule(tempModule[1]);
      }
    }

    setFiltersFromUrl(propLocation.search);

    if (propLocation.pathname === PageRoute.home) {
      filterAds();
    }

    scrollToTop();
  }, []);

  useEffect(() => {
    if (propModule && propModule !== prevProps.current.module) {
      selectedModule.current = propModule;
    }

    if (propLocation.search !== prevProps.current.location.search) {
      setFiltersFromUrl(propLocation.search);
    }

    prevProps.current = props;

    //   const prevSearch = prevProps.current.location.search;
    //  adjustSortOption(propLocation.search, prevSearch);

    const defaultSortOption = getDefaultSortOption(queryParams.current.filters);
    queryParams.current = {
      ...queryParams.current,
      filters: {
        ...queryParams.current.filters,
        // @ts-ignore
        sortOption: defaultSortOption
      }
    };
    sortOption.current = defaultSortOption;

  }, [propModule, propLocation]);

  const setFiltersFromUrl = search => {
    const filters = getUrlParams(search, QueryParam.searchQuery);

    queryParams.current = {
      ...queryParams.current,
      filters,
      page: filters ? filters.page : undefined
    };
  };

  const adjustSortOption = (search, prevSearch) => {
    const prevFilters = getUrlParams(prevSearch, QueryParam.searchQuery);
    const filters = getUrlParams(search, QueryParam.searchQuery);

    // if user search with text again set search option to most relevant
    if (
      filters &&
      filters.text &&
      !(prevFilters && prevFilters.text === filters.text)
    ) {
      sortOption.current = AdsSortOption.mostRelevant;
      return false;
    }

    return true;
  };

  const getDefaultSortOption = filters => {
    let defaultSortOption;

    // if user already search chose option, keep it
    if (filters && filters.sortOption) {
      defaultSortOption = filters.sortOption;
    } else {
      // else if the user search using text set it to most relevant else post date descending
      defaultSortOption =
        filters && filters.text
          ? AdsSortOption.mostRelevant
          : AdsSortOption.DateDesc;
    }

    return defaultSortOption;
  };

  //  NOTE: this code is some kind of hack, i left this note if refactor caused some problems
  //const handleModalRef = ref => {
  //  if (!ref) {
  //    return;
  //  }
  //
  //  const component = ref;
  //  component.componentDidUpdate = () => {
  //    if (modalElement.current) {
  //      return;
  //    }
  //    // @ts-ignore
  //    bodyElement.current = document.getElementsByTagName("body").item(0);
  //   // @ts-ignore
  //    cacheBodyStyle.current = bodyElement.current.getAttribute("style");
  //    // @ts-ignore
  //    modalElement.current = document.getElementsByClassName(
  //      AntdModalClass
  //    )[0].parentElement.parentElement;
  //
  //   // @ts-ignore
  //    bodyElement.current.setAttribute("style", "");
  //    // @ts-ignore
  //    modalElement.current.style.display = "none";
  //  };
  //};

  const handleToggleFilter = () => {
    //if (isShowFilter) {
    //  // @ts-ignore
    //  bodyElement.current.setAttribute("style", "");
    //  // @ts-ignore
    //  modalElement.current.style.display = "none";
    //} else {
    //  // @ts-ignore
    //  bodyElement.current.setAttribute("style", cacheBodyStyle.current);
    //  // @ts-ignore
    //  modalElement.current.style.display = "block";
    //}
    setIsShowFilter(prev => !prev);
  };

  const filterAds = () => {
    const { onSubmit } = props;
    const { filters, page } = queryParams.current;
    const newQueryParams = { ...filters, page, sortOption: sortOption.current };

    onSubmit(
      selectedModule.current === AllTypeCategory.name
        ? undefined
        : selectedModule.current,
      newQueryParams
    );
  };

  const handleModuleChange = value => {
    const {
      location: { pathname, search },
      updateCriteriaModules,
      criteriaModules
    } = props;

    if (pathname) {
      updateCriteriaModules(selectedModule.current, `${pathname}${search}`);

      if (criteriaModules[value]) {
        const url = criteriaModules[value];
        // Strip search tracking params from cached module URL
        if (url.includes("search_type") || url.includes("search_query")) {
          const [path, qs] = url.split("?");
          const cp = new URLSearchParams(qs);
          cp.delete("search_type");
          cp.delete("search_query");
          history.push(cp.toString() ? `${path}?${cp.toString()}` : path);
        } else {
          history.push(url);
        }
        return;
      }

      const params = getUrlParams(search, QueryParam.searchQuery);
      let queryUrl = "";

      if (params && params.text) {
        queryUrl = stringifyURI({ text: params.text }, QueryParam.searchQuery, true);
      }

      const moduleRoute = value === AllTypeCategory.name ? "" : `/${value}`;
      history.push(`${moduleRoute}${PageRoute.search}${queryUrl}`);
    } else {
      selectedModule.current = value;
      queryParams.current.filters = {};
      queryParams.current.page = undefined;
      filterAds();
      // No URL change here (e.g. seller page filter modal stays open),
      // so explicitly reload controls so the new module's category-specific
      // fields render in the modal.
      dispatch(getControls(
        value === AllTypeCategory.name ? undefined : value,
        undefined,
        {},
        getAdvancedSearchConfig
      ));
    }
  };

  const handlePageChange = nextPage => {
    queryParams.current.page = nextPage;
    filterAds();
  };

  const handleSortClick = value => {
    queryParams.current.page = undefined;
    sortOption.current = value;
    filterAds();
  };

  const handleFilterSubmit = (values, isToggle = true) => {
    if (!values) return;
    const { text } = queryParams.current.filters || {};
    queryParams.current.filters = text
      ? { ...values, text }
      : values;

    queryParams.current.page = undefined;

    if (props.isMobile && isToggle) {
      handleToggleFilter();
    }

    filterAds();
  };

  //const renderTab = ({ name, displayName }) => {
  //  const { ads, children, loading } = props;
  //
  //  return (
  //    <Tabs.TabPane tab={displayName} key={name}>
  //      <AdsSection
  //        module={selectedModule.current}
  //        category={props.selectedCategory}
  //        onPageChange={handlePageChange}
  //        ads={ads}
  //        loading={loading}
  //      >
  //        {children}
  //      </AdsSection>
  //    </Tabs.TabPane>
  //  );
  //};

  const handleSave = event => {
    if (props.selectedCategory != "") {
      ReactGA.event({
        category: "Spremanje pretrage",
        action: "Click",
        label: `Otvaranje sprijemanja pretrage - ${hrPageName}`
      });
    } else {
      ReactGA.event({
        category: "Spremanje pretrage",
        action: "Click",
        label: `Otvaranje sprijemanja pretrage - Sve kategorije`
      });
    }
    event.preventDefault();

    props.onSaveClick();
  };

  // if AgeVerification state is not calculated yet, we should not render the ads
  if (!ageVerificationModal && (!checkEmptyArray(categories) || !checkEmptyArray(allModules))) {
    return null;
  }

  if (shouldShowModal) {
    return <AgeVerification />;
  }

  return (
    <React.Fragment>
      {isMobile ? (
        checkEmptyObject(metaData) ? (
          metaData.h1 && <h1 className={styles.mobileTitle}>{metaData.h1}</h1>
        ) : categoryName ? (
          <h1 className={styles.mobileTitle}>{categoryName}</h1>
        ) : null
      ) : null}
      {!isMobile ? null : (
        <HeaderMobile
          loading={loading}
          filters={queryParams.current.filters}
          hasSaveButton={hasSaveButton}
          onSave={handleSave}
          ads={ads}
          isMobile={isMobile}
          onToggleFilter={handleToggleFilter}
          onSortClick={handleSortClick}
          sortOption={sortOption.current}
        />
      )}
      {!isMobile ? (
        <div className={styles.filters}>
          {filterHeader}
          <FilterSection
            onSubmit={handleFilterSubmit}
            module={
              selectedModule.current === AllTypeCategory.name
                ? undefined
                : selectedModule.current
            }
            categories={categories}
            selectedCategory={selectedCategory}
            numberOfControls={numberOfControls}
            location={location}
            modules={modules}
            onModuleChange={handleModuleChange}
            openAllSearchRef={openAllSearchRef}
          >
            {(ads && ads.data && ads.data.length > 0 && isMounted && !forbiddAds) ? (
              <React.Fragment>
                <GoogleAd
                  className={styles.ads}
                  config={{
                    ...googleAds.searchResult.leftMenu,
                    id: "googleAds.searchResult.leftMenu"
                  }}
                />
                <StickyBox offsetTop={50}>
                  <GoogleAd
                    className={`${styles.ads} `}
                    config={{
                      ...googleAds.searchResult.leftMenuBottom,
                      id: "googleAds.searchResult.leftMenuBottom"
                    }}
                  />
                </StickyBox>
              </React.Fragment>
            ) : null}
          </FilterSection>
        </div>
      ) : (
        <Modal
          visible={isShowFilter}
          width="auto"
          style={modalStyle}
          closable={false}
          wrapClassName={styles.filterModal}
          bodyStyle={modalBodyStyle}
          footer={null}
          destroyOnClose={false}
        >
          {shouldRenderFilterSection ? (
            <FilterSection
              onSubmit={handleFilterSubmit}
              module={
                selectedModule.current === AllTypeCategory.name
                  ? undefined
                  : selectedModule.current
              }
              categories={categories}
              selectedCategory={
                selectedCategory ||
                (queryParams.current.filters &&
                  queryParams.current.filters.category) ||
                ""
              }
              initialFilters={queryParams.current.filters}
              numberOfControls={numberOfControls}
              location={location}
              onBackClick={handleToggleFilter}
              isMobile={isMobile}
              modules={modules}
              onModuleChange={handleModuleChange}
            />
          ) : (
            <FilterSectionLoader />
          )}
        </Modal>
      )}
      <div className={styles.contentWrapper}>
        {isMobile ? null : (
          <div className={styles.header}>
            <HeaderDesktop
              loading={loading}
              filters={queryParams.current.filters}
              ads={ads}
              onSave={handleSave}
              hasSaveButton={hasSaveButton}
              onSortClick={handleSortClick}
              sortOption={sortOption.current}
              metaData={metaData}
              categoryName={categoryName}
            />
          </div>
        )}
        <div
          className={`custom-tab ${!isMobile ? styles.adTabs : styles.adTabsMobile
            }`}
        >
          { //!modules ? (
            <AdsSection
              module={selectedModule.current}
              category={props.selectedCategory}
              onPageChange={handlePageChange}
              ads={ads}
              loading={loading}
              target={target}
              shouldHilightPromotedAds={shouldHilightPromotedAds}
              queryParams={queryParams}
            >
              {children}
            </AdsSection>
            // ) : (
            //   <Tabs
            //     type="card"
            //     onChange={handelModuleChange}
            //     activeKey={selectedModule.current}
            //   >
            //     {renderTab(AllTypeCategory)}
            //     {modules.map(m => renderTab(m))}
            //   </Tabs>
            // )
          }
        </div>
        {(ads && ads.data && ads.data.length > 0 && isMounted && !forbiddAds) ? (
          <div className={styles.bottomAds}>
            {isMobile ? (
              <GoogleAd
                config={{
                  ...googleAds.searchResultMobile.box5,
                  id: "googleAds.searchResultMobile.box5"
                }}
              />
            ) : (
              <GoogleAd
                config={{
                  ...googleAds.searchResult.bottom1,
                  id: "googleAds.searchResult.bottom1"
                }}
              />
            )}
          </div>
        ) : null}
      </div>
      {showFloatingFilter && (
        <div className={styles.floatingFilterBtn} onClick={handleFloatingFilterClick}>
          <img alt="Filtriraj" src={getIconUrl("search-white.svg")} />
          {numberOfControls > 0 && (
            <span className={styles.floatingFilterBadge}>{numberOfControls}</span>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

SearchSection.defaultProps = {
  ads: null,
  module: "",
  children: null,
  selectedCategory: "",
  location: { search: "" },
  onSaveClick: () => null,
  hasSaveButton: false,
  numberOfControls: null,
  modules: [],
  isMobile: false,
  updateCriteriaModules: () => null,
  criteriaModules: {},
  shouldHilightPromotedAds: false
};

export default connect(null, { updateCurrentModule })(SearchSection);



// WEBPACK FOOTER //
// ./src/containers/SearchPage/SearchSection/SearchSection.tsx